export default {
  id: 16,
  pride: 1024,
  slug: "intelligent-glory",
  category: "game",
  status: "archived",
  experienceable: false,
  titleKey: {
    zh: "智能荣光",
    en: "Intelligent Glory"
  },
  image: require('@/assets/images/ig.webp'),
  descriptionKey: {
    zh: "对战的弹幕互动游戏，因为觉得UE5那个水体插件很好看就做了。目前不可玩。",
    en: "A PvP bullet comment interactive game, created because I liked the UE5 water plugin. Currently not playable."
  },
  date: { year: 2022, month: 5 },
  genres: ["弹幕互动", "对战"],
  themes: ["竞技"],
  engine: "虚幻引擎 5.1",
  platform: ["Web"],
  developerNotesKey: {
    zh: "对战的弹幕互动游戏，因为觉得UE5那个水体插件很好看就做了。目前不可玩。",
    en: "A PvP bullet comment interactive game, created because I liked the UE5 water plugin. Currently not playable."
  },
  tags: ["UE5"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1o34y1h7Pu/", textKey: { zh: "反杀局集锦", en: "Comeback Highlights" } },
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1uF41177C6/", textKey: { zh: "UE5水体介绍", en: "UE5 Water Plugin Showcase" } }
  ]
};
